export const version = '2.47.5'
